import {theme} from "Theme";

import {usePermitTreesTable} from "tree/data";

import {PermitExtensionTreesEditableCells} from ".";
import {SimpleTable} from "base/table/components";

import Stack from "@mui/system/Stack";
import Typography from "@mui/material/Typography";

const PermitExtensionTreesTable = ({
    extension,
    displayFees = false,
    disabled = false,
}) => {
    const trees = extension?.tree_set;
    const {tableColumns} = usePermitTreesTable(displayFees, true);

    return (
        <>
            <SimpleTable
                dataRows={trees}
                tableColumns={[
                    ...tableColumns,
                    {
                        id: "extension_trees",
                        align: "center",
                        label: (
                            <Stack
                                alignItems="center"
                                sx={{
                                    mb: -1,
                                    mr: -0.24,
                                    borderLeft: `3px solid ${theme.palette.primary.main}`,
                                    backgroundColor:
                                        theme.palette.pageBackground.secondary,
                                }}
                            >
                                <Typography variant="subtitle2" pt={1}>
                                    Prorrogação
                                </Typography>
                                <Stack direction="row">
                                    <Typography
                                        variant="caption"
                                        fontSize="11px"
                                        minWidth={40}
                                        textAlign="center"
                                    >
                                        Abate
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        fontSize="11px"
                                        minWidth={40}
                                        textAlign="center"
                                    >
                                        Serr.
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        fontSize="11px"
                                        minWidth={64}
                                        textAlign="center"
                                    >
                                        Nº toros
                                    </Typography>
                                </Stack>
                            </Stack>
                        ),
                        formatFunction: tree => {
                            return (
                                <PermitExtensionTreesEditableCells
                                    tree={tree}
                                    extension={extension}
                                    disabled={disabled}
                                />
                            );
                        },
                    },
                ]}
            />
        </>
    );
};

export default PermitExtensionTreesTable;
